/**
 * «⚖️ Частые правовые основания» — `#legalBlock` (ui-blocks.md §6.2).
 *
 * Топ-10 норм за период (DECISIONS.md: ТЗ просит 10, макет показывал 8).
 * Названия законов сокращаются `shortLaw()` — замены перенесены из макета
 * дословно. Блок видит только главврач.
 *
 * Клик по строке открывает список дел с этой нормой (ТЗ §8.2):
 * `GET /api/dashboard/list?kpi=legal&citation=<строка>` — в `citation` уходит
 * полная строка нормы, как её отдал бэкенд, а не сокращённая подпись.
 */

import type { KeyboardEvent } from 'react';
import { HEAD_NOTE_SM, barWidth, shortLaw } from './format';
import type { LegalBlock, OpenList } from './types';

interface Props {
    legal: LegalBlock;
    openList: OpenList;
}

export function LegalBasisBlock({ legal, openList }: Props) {
    const rows = legal.rows;
    const max = rows.reduce((m, r) => Math.max(m, r.count), 1);

    const open = (citation: string): void => {
        openList({
            title: `Дела с нормой: ${shortLaw(citation)}`,
            kpi: 'legal',
            params: { citation },
        });
    };

    const onKeyDown = (event: KeyboardEvent<HTMLDivElement>, citation: string): void => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        open(citation);
    };

    return (
        <div className="stat-block" id="legalBlock">
            <div className="block-header">
                <span>⚖️ Частые правовые основания</span>
                <span style={HEAD_NOTE_SM}>за период</span>
            </div>
            <div className="block-body" id="legalBody">
                {rows.length === 0 ? (
                    <div className="detail-empty">
                        За выбранный период правовые основания не зафиксированы.
                    </div>
                ) : (
                    rows.map((row) => (
                        <div
                            className="legal-row"
                            key={row.citation}
                            data-citation={row.citation}
                            role="button"
                            tabIndex={0}
                            onClick={() => open(row.citation)}
                            onKeyDown={(event) => onKeyDown(event, row.citation)}
                        >
                            <span className="lg-name">{shortLaw(row.citation)}</span>
                            <span className="cat-bar">
                                <i style={{ width: barWidth(row.count, max), background: '#8a63b8' }} />
                            </span>
                            <span className="lg-num">{row.count}</span>
                        </div>
                    ))
                )}
            </div>
            <div className="totals-row" id="legalTotals">
                {rows.length > 0 && (
                    <>
                        <span>Всего ссылок на нормы за период</span>
                        <span>
                            <b>{legal.total}</b>
                        </span>
                    </>
                )}
            </div>
        </div>
    );
}
